import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { accountTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const deactivateAccount: accountTypes.DeactivateAccount = ({ id }) => {
  return axios.patch(`/accounts/${id}/deactivate`);
};

type UseDeactivateAccountOptions = {
  config?: MutationConfig<typeof deactivateAccount>;
};

export function useDeactivateAccount({ config = {} }: UseDeactivateAccountOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('deactivate-account', 'Deactivating account...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['accounts']);
      toasts.loadingToast.success('deactivate-account', 'Account deactivated successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('deactivate-account', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: deactivateAccount,
  });
}
